
export type Purchase = {
  name: string
  city: string
  country: string
}

/**
 * Social-proof feed for the purchase notifications.
 * Edit this list to match verified purchases.
 */
export const PURCHASES: Purchase[] = [
  {
    name: 'Valentina',
    city: 'Ciudad de México',
    country: 'México',
  },
  {
    name: 'Sebastián',
    city: 'Bogotá',
    country: 'Colombia',
  },
  {
    name: 'Camila',
    city: 'Santiago',
    country: 'Chile',
  },
  {
    name: 'Diego',
    city: 'Lima',
    country: 'Perú',
  },
  {
    name: 'Lucía',
    city: 'Madrid',
    country: 'España',
  },
  {
    name: 'Andrés',
    city: 'Guayaquil',
    country: 'Ecuador',
  },
  {
    name: 'Martina',
    city: 'Montevideo',
    country: 'Uruguay',
  },
  {
    name: 'Joaquín',
    city: 'Santa Cruz',
    country: 'Bolivia',
  },
  {
    name: 'Daniela',
    city: 'San José',
    country: 'Costa Rica',
  },
  {
    name: 'Emilia',
    city: 'Ciudad de Guatemala',
    country: 'Guatemala',
  },
  {
    name: 'Mateo',
    city: 'Santo Domingo',
    country: 'República Dominicana',
  },
  {
    name: 'Sofía',
    city: 'Asunción',
    country: 'Paraguay',
  },
  {
    name: 'Tomás',
    city: 'Barcelona',
    country: 'España',
  },
  {
    name: 'Renata',
    city: 'Monterrey',
    country: 'México',
  },
  {
    name: 'Nicolás',
    city: 'Medellín',
    country: 'Colombia',
  },
]
export const TIME_AGOS = [
  'hace 2 minutos',
  'hace 4 minutos',
  'hace 7 minutos',
  'hace 11 minutos',
  'hace 16 minutos',
  'hace 24 minutos',
  'hace 38 minutos',
  'hace 1 hora',
]
